import { styled } from '@linaria/react'
import { BaseCardSC, TopVodSimpleCardBaseSC } from 'blocks/Cards/base-card'
import { SHADOW } from 'vars/shadow'
import { VodSimpleCardSC } from './MovieCardTemplate.styled'

export const VodSimpleCardContainerSC = styled.div`
  &:hover,
  ${TopVodSimpleCardBaseSC}:hover & {
    ${VodSimpleCardSC} {
      box-shadow: var(${SHADOW.CARD});
    }
  }
`

export const TopVodSimpleCardSC = styled(TopVodSimpleCardBaseSC)`
  position: relative;
  width: 100%;
  height: 100%;

  ${VodSimpleCardContainerSC} {
    position: absolute;
    top: 0;
    right: 0;
    aspect-ratio: ${({ aspectRatio }) => aspectRatio ?? 'initial'};
    height: 100%;
    width: initial;

    ${BaseCardSC} {
      height: 100%;
      width: 100%;
    }
  }
`
